import { Box, Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { Spinner, UserSelect } from '@treams/treams-ui';
import { ComponentProps } from 'react';
import type LearningEventAttendee from './LearningEventAttendee';

export type IQueueJoinInput = ComponentProps<typeof LearningEventAttendee>['user'] & {
	attendeeType: graphql.LearningEventAttendeeType;
};

export default function LearningEventInviteAttendee(props: {
	event?: graphql.LearningEvent;
	attendeeType: graphql.LearningEventAttendeeType;
	queueJoin?: (input: IQueueJoinInput) => void;
	queuedHosts?: IQueueJoinInput[];
}) {
	const [join, { loading }] = graphql.useJoinLearningEventMutation();

	return (
		<Flex alignItems="center">
			<UserSelect
				excluded={
					props.event
						? props.event.hosts.edges.map(({ node }) => node).map((user) => user.id)
						: (props.queuedHosts?.map((user) => user.id) ?? [])
				}
				setSelected={(_, user) => {
					if (!props.event) {
						props.queueJoin?.({ ...user, attendeeType: props.attendeeType });

						return;
					}

					join({
						variables: {
							input: {
								learningEventID: props.event.id,
								userID: user.id!,
								attendeeType: props.attendeeType,
							},
						},
					});
				}}
			/>
			{loading && (
				<Box ml={2}>
					<Spinner />
				</Box>
			)}
		</Flex>
	);
}
